var ChatbotModel = /** @class */ (function () {
    function ChatbotModel(direction, message) {
        this.Direction = direction;
        this.Message = message;
    }
    return ChatbotModel;
}());
export { ChatbotModel };
